export const EXPERTS_GET_LIST = 'EXPERTS_GET_LIST';
export const EXPERTS_GET_LIST_SUCCESS = 'EXPERTS_GET_LIST_SUCCESS';
export const EXPERTS_GET_LIST_ERROR = 'EXPERTS_GET_LIST_ERROR';
export const EXPERTS_GET_LIST_WITH_FILTER = 'EXPERTS_GET_LIST_WITH_FILTER';
export const EXPERTS_GET_LIST_WITH_ORDER = 'EXPERTS_GET_LIST_WITH_ORDER';
export const EXPERTS_GET_LIST_SEARCH = 'EXPERTS_GET_LIST_SEARCH';


export const EXPERTS_DELETE_ITEMS = 'EXPERTS_DELETE_ITEMS';
export const EXPERTS_DELETE_ITEMS_SUCCESS = 'EXPERTS_DELETE_ITEMS_SUCCESS';
export const EXPERTS_DELETE_ITEMS_ERROR = 'EXPERTS_DELETE_ITEMS_ERROR';


export const EXPERTS_SELECTED_ITEMS_CHANGE = 'EXPERTS_SELECTED_ITEMS_CHANGE';
